<script>
    import Checked from "./icons/Checked.svelte";
    import Unchecked from "./icons/Unchecked.svelte";

    export let label;
    export let checked;
</script>

<div class="root" on:click>
    <span class="label">{label}</span>
    {#if checked}
        <Checked />
    {:else}
        <Unchecked />
    {/if}
</div>

<style>
    .root {
        display: flex;
        align-items: center;

        cursor: pointer;
    }
    .label {
        font-size: 14px;
        
        min-width: 30px;
        margin-top: 4px;
        margin-left: 16px;
        margin-right: 4px;
    }
</style>